(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["warmies-home-tabbed-rail"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const rails = document.querySelectorAll('[data-warmies-tabbed-rail]');

    const initRail = (rail) => {
      if (!rail || rail.dataset.warmiesRailReady === 'true') return;
      rail.dataset.warmiesRailReady = 'true';

      const tabs = Array.from(rail.querySelectorAll('[role="tab"]'));
      const panels = Array.from(rail.querySelectorAll('[role="tabpanel"]'));
      const prevButton = rail.querySelector('[data-rail-prev]');
      const nextButton = rail.querySelector('[data-rail-next]');
      const shouldRandomize = rail.dataset.randomizeProducts === 'true';

      if (!tabs.length || !panels.length) return;

      const shuffle = (items) => {
        const shuffled = [...items];

        for (let index = shuffled.length - 1; index > 0; index -= 1) {
          const randomIndex = Math.floor(Math.random() * (index + 1));
          [shuffled[index], shuffled[randomIndex]] = [shuffled[randomIndex], shuffled[index]];
        }

        return shuffled;
      };

      const selectedProductIds = new Set();

      for (const panel of panels) {
        const scroller = panel.querySelector('[data-rail-scroller]');
        if (!scroller) continue;

        const candidates = Array.from(scroller.querySelectorAll('[data-rail-product]'));
        const visibleLimit = Number.parseInt(scroller.dataset.visibleLimit || '0', 10);
        const orderedCandidates = shouldRandomize ? shuffle(candidates) : candidates;
        const uniqueCandidates = orderedCandidates.filter(
          (card) => !selectedProductIds.has(card.dataset.productId)
        );
        const repeatedCandidates = orderedCandidates.filter(
          (card) => selectedProductIds.has(card.dataset.productId)
        );
        const selectedCards = uniqueCandidates.slice(0, visibleLimit);

        if (selectedCards.length < visibleLimit) {
          selectedCards.push(...repeatedCandidates.slice(0, visibleLimit - selectedCards.length));
        }

        const selectedSet = new Set(selectedCards);
        for (const card of candidates) {
          card.hidden = !selectedSet.has(card);
        }

        for (const card of selectedCards) {
          scroller.append(card);
          selectedProductIds.add(card.dataset.productId);
        }

        for (const card of candidates) {
          if (!selectedSet.has(card)) scroller.append(card);
        }

        scroller.dataset.selectedHandles = selectedCards
          .map((card) => card.dataset.productHandle)
          .join(',');
      }

      let activeIndex = Math.max(
        0,
        tabs.findIndex((tab) => tab.getAttribute('aria-selected') === 'true')
      );

      const getScroller = () => panels[activeIndex]?.querySelector('[data-rail-scroller]');

      const updateArrowState = () => {
        const scroller = getScroller();
        if (!prevButton || !nextButton || !scroller) return;

        const maxScroll = Math.max(0, scroller.scrollWidth - scroller.clientWidth);
        const isScrollable = maxScroll > 8;

        prevButton.disabled = !isScrollable || scroller.scrollLeft <= 8;
        nextButton.disabled = !isScrollable || scroller.scrollLeft >= maxScroll - 8;
      };

      const activateTab = (nextIndex, focusTab = false) => {
        activeIndex = nextIndex;

        tabs.forEach((tab, index) => {
          const isActive = index === nextIndex;
          tab.setAttribute('aria-selected', isActive ? 'true' : 'false');
          tab.tabIndex = isActive ? 0 : -1;
          if (focusTab && isActive) tab.focus();
        });

        panels.forEach((panel, index) => {
          panel.hidden = index !== nextIndex;
        });

        updateArrowState();
      };

      tabs.forEach((tab, index) => {
        tab.addEventListener('click', () => activateTab(index, false));
        tab.addEventListener('keydown', (event) => {
          let nextIndex = null;

          if (event.key === 'ArrowRight') nextIndex = (index + 1) % tabs.length;
          if (event.key === 'ArrowLeft') nextIndex = (index - 1 + tabs.length) % tabs.length;
          if (event.key === 'Home') nextIndex = 0;
          if (event.key === 'End') nextIndex = tabs.length - 1;

          if (nextIndex === null) return;

          event.preventDefault();
          activateTab(nextIndex, true);
        });
      });

      [prevButton, nextButton].forEach((button) => {
        if (!button) return;

        button.addEventListener('click', () => {
          const scroller = getScroller();
          if (!scroller) return;

          const direction = button === nextButton ? 1 : -1;
          scroller.scrollBy({
            left: Math.round(scroller.clientWidth * 0.88) * direction,
            behavior: 'smooth',
          });
        });
      });

      panels.forEach((panel) => {
        const scroller = panel.querySelector('[data-rail-scroller]');
        if (!scroller) return;
        scroller.addEventListener('scroll', updateArrowState, { passive: true });
      });

      window.addEventListener('resize', updateArrowState, { passive: true });

      activateTab(activeIndex, false);
    };

    rails.forEach(initRail);

    document.addEventListener('shopify:section:load', (event) => {
      if (event.target?.matches?.('[data-warmies-tabbed-rail]')) {
        initRail(event.target);
      }
      event.target?.querySelectorAll?.('[data-warmies-tabbed-rail]').forEach(initRail);
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
